import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useGetUsersTags = function useGetUsersTags(isCustomTagsEnabled) {
  return useQuery(["usersTags"], function () {
    return servicesUtils.getService("/tags/");
  }, {
    enabled: isCustomTagsEnabled
  });
};
export default useGetUsersTags;